module.exports = __webpack_public_path__ + "static/media/stem.e3c391e2.mp4";